import { diContainer, serviceNames } from '../diContainer/diContainer';
import UserPreferencesRepository from '../repositories/UserPreferencesRepository';

class ToggleSubscriptionUseCase {
  public execute = async (): Promise<void> => {
    const userPreferencesRepository: UserPreferencesRepository = diContainer.get(
      serviceNames.userPreferencesRepository,
    );
    const { userPreferences } = userPreferencesRepository;
    userPreferences.setSubscribed(!userPreferences.subscribed);
  };
}

export default ToggleSubscriptionUseCase;
